import { render } from "./DefEmpty.vue?vue&type=template&id=5b9ffb8b&scoped=true"
import script from "./DefEmpty.vue?vue&type=script&lang=js"
export * from "./DefEmpty.vue?vue&type=script&lang=js"

import "./DefEmpty.vue?vue&type=style&index=0&id=5b9ffb8b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9ffb8b"]])

export default __exports__